module.exports = __webpack_public_path__ + "img/tooltip_litho-board-1.2e9b8fc6.jpg";